import React from 'react';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import CardContent from '@mui/material/CardContent';
import NewDeploymentSteps from './NewDeploymentSteps';
import { useNavigate } from 'react-router-dom';
import Stack from '@mui/material/Stack';
import IconButton from '@mui/material/IconButton';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { DEPLOYMENTS_PATH, DEPLOYMENTS_VIEW_PATH } from '../../../../routes';
import Grid from '@mui/material/Grid';

const NewDeploymentConfiguration = () => {
  const navigate = useNavigate();

  const handleGoToMainDeploymentView = () => {
    navigate(DEPLOYMENTS_PATH);
  };

  const handleGoToDeploymentListView = () => {
    navigate(DEPLOYMENTS_VIEW_PATH);
  };

  return (
    <>
      <Stack direction='row' spacing={1} alignItems='center' sx={{ pb: 2 }}>
        <IconButton aria-label='back to deployment view' onClick={() => {
          handleGoToMainDeploymentView();
        }}>
          <ArrowBackIcon />
        </IconButton>
        <Typography variant='h5'>Create New Deployment</Typography>
      </Stack>
      <Grid container>
        <Grid item xs={12}>
          <Card>
            <CardContent>
              <NewDeploymentSteps
                onGoToDeploymentMainView={handleGoToMainDeploymentView}
                onGoToDeploymentListView={handleGoToDeploymentListView}
              />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </>
  );
};

export default NewDeploymentConfiguration;
